<template>
  <div>
    <v-stepper
      :class="
        `elevation-0 primary ${$route.name === 'rmas' ? 'lighten-1' : ''}`
      "
      xs12
      style="border: none"
    >
      <v-stepper-header xs12>
        <template v-for="(step, index) in states">
          <v-stepper-step
            color="secondary"
            :key="`step-${index}`"
            :complete="index <= isCurrentState"
            :step="index + 1"
            >{{ step }}</v-stepper-step
          >
        </template>
      </v-stepper-header>
    </v-stepper>
  </div>
</template>

<script>
export default {
  name: "process-flow",
  props: ["currentState", "states"],

  data() {
    return {
      e1: 1,
      stateIndex: 0
    };
  },

  mounted() {},

  computed: {
    isCurrentState() {
      return this.states.findIndex(state => {
        return state === this.currentState;
      });
    }
  }
};
</script>
